import { specialistRequests } from "api/specialistApi";
import React from "react";
import {
  ArrayInput,
  Button,
  FormDataConsumer,
  required,
  SelectInput,
  SimpleFormIterator,
  useNotify,
  useRecordContext,
} from "react-admin";
import FormModal from "server/components/Modals/FormModal";
import dataProvider from "server/dataProvider";
import AddIcon from "@mui/icons-material/Add";
import { Grid } from "@mui/material";

const AddCurriculaPrerequisitesDialog = ({ curriculumId, fetchCurriculaPrerequisites }) => {
  const notify = useNotify();
  const record = useRecordContext();

  const itemChoices = (record?.modules || []).flatMap(module =>
    (module.items || []).map(item => ({
      id: item.id,
      name: `${module.nameBg} / ${item.nameBg}`,
    })),
  );

  const handleSubmit = async data => {
    const payload = {
      items: (data.items || []).map(item => ({
        itemId: item.itemId,
        prerequisiteItemId: item.prerequisiteItemId,
      })),
    };
    await dataProvider.customRequest(specialistRequests.postCurriculaPrerequisites(curriculumId), payload, "POST");
    notify("Успешно добавяне на изисквания за Учебен план", { type: "success" });
    fetchCurriculaPrerequisites();
  };

  return (
    <FormModal
      titleContent={"Добавяне на предпоставки за Учебен план"}
      dialogSize="md"
      onConfirm={handleSubmit}
      triggerButton={
        <Button
          label="Добави предпоставки"
          variant="contained"
          startIcon={<AddIcon />}
          sx={{ mt: 2, ml: 2 }}
        />
      }
    >
      <ArrayInput
        source="items"
        label="Предпоставки"
        defaultValue={[{}]}
      >
        <SimpleFormIterator>
          <Grid
            container
            spacing={2}
          >
            <Grid
              item
              xs={12}
              md={6}
            >
              <FormDataConsumer>
                {({ scopedFormData }) => (
                  <SelectInput
                    source="itemId"
                    label="Тема"
                    choices={itemChoices.filter(c => c.id !== scopedFormData?.prerequisiteItemId)}
                    validate={[required()]}
                    fullWidth
                  />
                )}
              </FormDataConsumer>
            </Grid>
            <Grid
              item
              xs={12}
              md={6}
            >
              <FormDataConsumer>
                {({ scopedFormData }) => (
                  <SelectInput
                    source="prerequisiteItemId"
                    label="Предпоставка"
                    choices={itemChoices.filter(c => c.id !== scopedFormData?.itemId)}
                    validate={[required()]}
                    fullWidth
                  />
                )}
              </FormDataConsumer>
            </Grid>
          </Grid>
        </SimpleFormIterator>
      </ArrayInput>
    </FormModal>
  );
};

export default AddCurriculaPrerequisitesDialog;
